'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M14.043 20.619h-.633v-5.19h-2.82v5.19h-.633v-5.507c0-.174.142-.316.317-.316h3.452c.175 0 .317.142.317.316v5.507Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m12.213 4.877 6.827 6.21c.066.06.103.146.103.235v9.362a.317.317 0 0 1-.316.316H5.173a.316.316 0 0 1-.316-.316v-9.362c0-.09.037-.174.103-.234l6.827-6.211a.316.316 0 0 1 .426 0ZM12 5.539l-6.51 5.923v8.905h13.02v-8.905L12 5.539Zm-.209-2.46a.317.317 0 0 1 .418 0l3.176 2.794v-.897h.633v1.455l1.81 1.592V3.815h-3.074v-.634h4.347v.634h-.64V8.58L21 10.814l-.419.475L12 3.74l-8.582 7.55L3 10.814Z",
    fill: "#3F3E4B"
  })));
});
var FwSet0House = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0House = FwSet0House;